// extracted by mini-css-extract-plugin
export default {"tabNavItem":"_1jM_agB85ro8KTqaKQLsV1","tabNavLink":"_2zymDFcYzqrH365O57jJoN"};